import { GridGetRowsError } from "@mui/x-data-grid-premium";
import axios from "axios";

export const isTabularPageCancellation = (error: unknown): boolean => {
  const cause = error instanceof GridGetRowsError ? error.cause : error;
  return axios.isCancel(cause) || (cause instanceof Error && cause.name === "AbortError");
};
